import {
  ObligationRulesCategory,
  ObligationRulesFrequency,
} from '@prisma/client';

export const ComplianceFrequencyEnumToText: {
  [key in ObligationRulesFrequency]: string;
} = {
  [ObligationRulesFrequency.ANNUAL]: 'Annual',
  [ObligationRulesFrequency.QUARTERLY]: 'Quarterly',
  // Bi-Monthly here means every 2 months (6×/year), not twice a month.
  [ObligationRulesFrequency.BI_MONTHLY]: 'Bi-Monthly',
  [ObligationRulesFrequency.MONTHLY]: 'Monthly',
  [ObligationRulesFrequency.ONE_TIME]: 'One-Time',
  [ObligationRulesFrequency.DECENNIAL]: 'Decennial',
  [ObligationRulesFrequency.BIENNIAL]: 'Biennial',
  [ObligationRulesFrequency.SEMI_ANNUAL]: 'Semi-Annual',
  [ObligationRulesFrequency.AS_NEEDED]: 'As Needed',
};

export const ComplianceCategoryEnumToText: {
  [key in ObligationRulesCategory]?: string;
} = {
  [ObligationRulesCategory.DIRECT_TAX]: 'Direct Tax',
  [ObligationRulesCategory.INDIRECT_TAX]: 'Indirect Tax',
  [ObligationRulesCategory.TRANSFER_PRICING]: 'Transfer Pricing',
  [ObligationRulesCategory.ENTITY_COMPLIANCE]: 'Entity Compliance',
  [ObligationRulesCategory.PAYROLL_AND_EMPLOYMENT]: 'Payroll and Employment',
  [ObligationRulesCategory.CUSTOMS_AND_TRADE]: 'Customs and Trade',
};

export const OrderedComplianceCategories: ObligationRulesCategory[] = [
  ObligationRulesCategory.DIRECT_TAX,
  ObligationRulesCategory.INDIRECT_TAX,
  ObligationRulesCategory.TRANSFER_PRICING,
  ObligationRulesCategory.ENTITY_COMPLIANCE,
  ObligationRulesCategory.PAYROLL_AND_EMPLOYMENT,
  ObligationRulesCategory.CUSTOMS_AND_TRADE,
];
